import type { ContextProps, ContextServices } from '../../../types';
import { addLocationChangeHandler } from './location';
import { addLoginHandler } from './login';
import { handleNavigation } from './navigation';
import { addInitialDataForWidgetPlugins } from './widget-plugins';

export const oldAddHandlers = (
  contextProps: ContextProps,
  contextServices: ContextServices,
) => {
  addInitialDataForWidgetPlugins(contextProps, contextServices);
  addLocationChangeHandler(contextProps, contextServices);
  addLoginHandler(contextProps, contextServices);

  return handleNavigation(contextProps, contextServices);
};

export const addHandlers = (
  contextProps: ContextProps,
  contextServices: ContextServices,
) => {
  addLocationChangeHandler(contextProps, contextServices);
  addLoginHandler(contextProps, contextServices);
};

export { addInitialDataForWidgetPlugins, handleNavigation };
